"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVue3AppPackage = createVue3AppPackage;
const vue_1 = require("vue");
function declaredProps(component, config) {
    const props = component.props;
    const names = Array.isArray(props) ? props : Object.keys(props ?? {});
    const rootProps = {};
    for (const name of names.map(vue_1.camelize)) {
        if (Object.prototype.hasOwnProperty.call(config, name))
            rootProps[name] = config[name];
    }
    return rootProps;
}
function createVue3AppPackage(appComponent, setup) {
    return new class Vue3App {
        async create(elOrConfig, configParam) {
            const config = typeof configParam !== 'undefined' ? configParam : elOrConfig;
            let el = typeof configParam !== 'undefined' ? elOrConfig : undefined;
            if (!el && typeof elOrConfig === 'object') {
                el = elOrConfig.el;
            }
            const comp = await appComponent();
            const instance = await setup((0, vue_1.createApp)(comp, declaredProps(comp, config)), config);
            const packageInstance = {
                config,
                instance,
                mount(el) {
                    this.componentInstance = this.instance.mount(el);
                    return Promise.resolve();
                },
                unmount() {
                    this.instance.unmount();
                    return Promise.resolve();
                },
                update(config) {
                    Object.assign(this.config, config);
                    if (this.componentInstance) {
                        this.componentInstance.$forceUpdate();
                    }
                    return Promise.resolve();
                }
            };
            if (el) {
                await packageInstance.mount(el);
            }
            return packageInstance;
        }
    };
}
